// teams

const getters = {
	getTeams(state) {
		return state.teams;
	},
	getTeam(state) {
		return state.team;
	},

};

export default getters;